import { render, staticRenderFns } from "./StandalonesList.vue?vue&type=template&id=15a73000&scoped=true&"
import script from "./StandalonesList.vue?vue&type=script&lang=ts&"
export * from "./StandalonesList.vue?vue&type=script&lang=ts&"
import style0 from "./StandalonesList.vue?vue&type=style&index=0&id=15a73000&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a73000",
  null
  
)

export default component.exports